export function getSystemDay() {

  let fechaActual = new Date();

  // Obtiene el año, mes y día de la fecha actual
  const year = fechaActual.getFullYear();
  const month = (fechaActual.getMonth() + 1).toString().padStart(2, "0"); // El mes es de 0 a 11, se suma 1
  const day = fechaActual.getDate().toString().padStart(2, "0");

  // Formatea la fecha en el formato 'YYYY-MM-DD'
  const fechaFormateada = `${year}-${month}-${day}`;

  return fechaFormateada;
}

export const hourFormat = time => {
  let format = new Date(time);
  let hour = format.getHours();
  let minutes = format.getMinutes();
  hour = ("0" + hour).slice(-2);
  minutes = ("0" + minutes).slice(-2);

  return `${hour}:${minutes}`;
}

export const dateFormat = time => {
  let format = new Date(time);
  var month = format.toLocaleDateString('es-ES', { month: "long" });
  month = month.charAt(0).toUpperCase() + month.slice(1);
  var day = format.toLocaleDateString('es-ES', { day: "numeric" });
  return `${month} ${day}`;
}

export const dateFormatInverse = time => {
  let format = new Date(time);
  var month = format.toLocaleDateString('es-ES', { month: "long" });
  month = month.charAt(0).toUpperCase() + month.slice(1);
  var day = format.toLocaleDateString('es-ES', { day: "numeric" });
  return `${day} ${month}`;
}

export const dateFormatInverseShort = time => {
  let format = new Date(time);
  var month = format.toLocaleDateString('es-ES', { month: "short" });
  month = month.charAt(0).toUpperCase() + month.slice(1);
  var day = format.toLocaleDateString('es-ES', { day: "numeric" });
  return `${day} ${String(month).toLowerCase()}`;
}

export function getLabelDate(initialDate) {
  let day = dateFormat(initialDate);

  return day;

}

export function getParisSystemDayParis() {
  // Crear una fecha actual en UTC
  const fechaActual = new Date();

  // Usar toLocaleString para obtener la fecha en la zona horaria de París
  const opciones = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    timeZone: 'America/Mexico_City'
    // 'Europe/Paris'
    // timeZone: 'Asia/Tokyo'
  };

  // Convertir la fecha a un string en el formato deseado
  const fechaFormateada = fechaActual.toLocaleString('sv-SE', opciones).split(' ')[0];

  return fechaFormateada;
}